// Generated by Melange

import * as Fx from "../fx/fx.jsx";
import * as MergeIntoMap from "../mergeIntoMap/mergeIntoMap.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Subsonic__GetTopSongs from "../api/subsonic/getTopSongs.jsx";

function make(artistName) {
  return Fx.Monad_syntax.let$star(Fx.ask(undefined), (function (param) {
    const store = param.store;
    const state = store.getState();
    return Fx.Monad_syntax.let$star(Fx.provide(Subsonic__GetTopSongs.make(artistName, undefined, undefined), {
      credentials: state.auth.credentials
    }), (function (songs) {
      const arg = [];
      const songs$1 = (function (param) {
        return Stdlib__Option.value(param, arg);
      })(songs);
      const state = store.getState();
      const topSongIdsByArtistName = MergeIntoMap.mergeIntoMap(state.artists.topSongIdsByArtistName, [songs$1.map(function (song) {
          return song.id;
        })], (function (param) {
        return artistName;
      }));
      const state$1 = store.getState();
      const songsById = MergeIntoMap.mergeIntoMap(state$1.songs.byId, songs$1, (function (song) {
        return song.id;
      }));
      const state$2 = store.getState();
      if (topSongIdsByArtistName !== state$2.artists.topSongIdsByArtistName || songsById !== state$2.songs.byId) {
        store.setState(function (prevState) {
          const init = prevState.artists;
          return {
            albums: prevState.albums,
            artists: {
              albumIdsByArtistId: init.albumIdsByArtistId,
              artistInfoById: init.artistInfoById,
              byId: init.byId,
              listIds: init.listIds,
              similarArtistsById: init.similarArtistsById,
              topSongIdsByArtistName: topSongIdsByArtistName
            },
            auth: prevState.auth,
            player: prevState.player,
            songs: {
              byId: songsById
            }
          };
        });
      }
      return {
        TAG: /* Ok */ 0,
        _0: undefined
      };
    }));
  }));
}

export {
  make,
}
/* MergeIntoMap Not a pure module */
